/**
 * @file ServiceHardwarePage.jsx
 * @description SERVICE department — Hardware Installation.
 *
 * The hardware workshop (register → test → install → monitor) in its service
 * guise: the service team runs the TCU installations in the field, so the
 * whole workshop — most importantly the Testing tab's receiving-data checks —
 * lives behind a Service header.
 *
 * This file belongs to the SERVICE department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for SERVICE is made HERE and can never leak into another
 * department's screens. The shared engine underneath (HardwarePage) and the
 * backend stay common — only the department-facing page is departmental.
 * Route access is department-gated in utils/permissions.js: only SERVICE
 * users (and the super admin) can open it.
 */
import React from 'react';
import HardwarePage from '../HardwarePage';

const ServiceHardwarePage = () => (<HardwarePage />);

export default ServiceHardwarePage;
